<div class="selection selection--selected">
    @if (previousResource) {
    <app-button
        class="outset-with-icon outset-with-icon--navigation"
        (click)="handleNavigateToPreviousResource()"
    >
        <i class="fas fa-arrow-left"></i>
        Terug
    </app-button>
    } @for (resource of selectedResources; track resource) {
    <app-button
        [modifiers]="[resource | methodMapping: 'bg']"
        [disabled]="loading"
        (click)="handleNavigationHistoryClick(resource)"
    >
        {{ resource.getName() }}
    </app-button>
    }
</div>
<ng-container>
    @if (0 !== currentResources.length) {
    <h1 class="h1" i18n>Kies een {{ currentResources | selectMethod }}</h1>
    }
    <div class="selection-container">
        <div class="selection" #activeFaderContainer appFader>
            @for (resource of currentResources; track resource) {
            <app-button
                [modifiers]="[resource | methodMapping: 'outline']"
                (click)="handleNavigationClick(resource)"
            >
                {{ resource.getName() }}
            </app-button>
            }
        </div>
        <div
            class="selection selection--history"
            #inactiveFaderContainer
            appFader
        >
            @for (resource of inactiveResources; track resource) {
            <app-button
                [modifiers]="[resource | methodMapping: 'outline', 'disabled']"
            >
                {{ resource.getName() }}
            </app-button>
            }
        </div>
    </div>
</ng-container>
